import { render } from "./vouchers-home.vue?vue&type=template&id=14ae30b8"
import script from "./vouchers-home.vue?vue&type=script&lang=js"
export * from "./vouchers-home.vue?vue&type=script&lang=js"
script.render = render

export default script